import React from 'react';
import AcademyLayout from './AcademyLayout';
import { sqlLessons } from '../../content/sql/lessons';

export default function SqlAcademy({ darkMode }) {
  return (
    <AcademyLayout
      darkMode={darkMode}
      lessons={sqlLessons}
      courseTitle="SQL Grundlagen"
      courseIcon="🗄️"
      backPath="/academy"
    />
  );
}
